import type { RouteRecordRaw } from 'vue-router';

import { ROUTES } from '@/constants/routes';
import i18n from '@/i18n';

import type { BreadcrumbProps } from '@/dsComponents/breadcrumbs/types';

const routes: RouteRecordRaw[] = [
	{
		path: 'workers',
		name: ROUTES.APP.WORKERS._ROOT,
		redirect: { name: ROUTES.APP.WORKERS.LIST },
		component: () =>
			import(/* webpackChunkName: "workers" */ './views/Layout.vue'),
		children: [
			{
				name: ROUTES.APP.WORKERS.LIST,
				path: 'list',
				component: () =>
					import(/* webpackChunkName: "workers" */ './views/List.vue'),
				meta: {
					breadcrumbs: <BreadcrumbProps>{
						items: [
							{
								label: i18n.global.t('breadcrumbs.workers.root'),
								icon: 'users',
								link: { name: ROUTES.APP.WORKERS._ROOT },
							},
						],
					},
				},
			},
			{
				name: ROUTES.APP.WORKERS.PLANNING,
				path: 'planning',
				component: () =>
					import(/* webpackChunkName: "workers" */ './views/Planning.vue'),
				meta: {
					breadcrumbs: <BreadcrumbProps>{
						items: [
							{
								label: i18n.global.t('breadcrumbs.workers.root'),
								icon: 'users',
								link: { name: ROUTES.APP.WORKERS._ROOT },
							},
							{
								label: i18n.global.t('breadcrumbs.workers.planning'),
							},
						],
					},
				},
			},
		],
	},
	{
		path: 'workers/:workerId',
		name: ROUTES.APP.WORKERS.PROFIL._ROOT,
		component: () =>
			import(
				/* webpackChunkName: "interim-profil" */ './views/profil/Layout.vue'
			),
		redirect: (to) => ({
			name: ROUTES.APP.WORKERS.PROFIL.CAREER,
			params: to.params,
		}),
		children: [
			// Profil section
			{
				path: 'career',
				name: ROUTES.APP.WORKERS.PROFIL.CAREER,
				component: () =>
					import(
						/* webpackChunkName: "workerCareer" */ './views/profil/Career.vue'
					),
			},
			{
				path: 'admin',
				name: ROUTES.APP.WORKERS.PROFIL.ADMIN,
				component: () =>
					import(
						/* webpackChunkName: "workerAdmin" */ './views/profil/Admin.vue'
					),
			},
			{
				path: 'documents',
				name: ROUTES.APP.WORKERS.PROFIL.INTERIM_DOCUMENTS,
				component: () =>
					import(
						/* webpackChunkName: "interimDocuments" */ './views/profil/WorkerDocument.vue'
					),
			},
			{
				path: 'schedule',
				name: ROUTES.APP.WORKERS.PROFIL.INTERIM_SCHEDULE,
				component: () =>
					import(
						/* webpackChunkName: "interimSchedule" */ './components/workerPlanning/WorkerPlanningCalendar.vue'
					),
			},
			// Historique section
			{
				path: 'suivi',
				name: ROUTES.APP.WORKERS.PROFIL.SUIVI,
				component: () =>
					import(
						/* webpackChunkName: "workerSuivi" */ './components/suivi/SuiviTimeline.vue'
					),
			},
			{
				path: 'missions',
				name: ROUTES.APP.WORKERS.PROFIL.INTERIM_MISSIONS,
				component: () =>
					import(
						/* webpackChunkName: "workerMissions" */ './components/workerMissions/WorkerMissions.vue'
					),
			},
			{
				path: 'applications',
				name: ROUTES.APP.WORKERS.PROFIL.INTERIM_JOBOFFERS,
				component: () =>
					import(
						/* webpackChunkName: "workerApplications" */ './components/workerApplications/WorkerApplications.vue'
					),
			},
			{
				path: 'propositions',
				name: ROUTES.APP.WORKERS.PROFIL.INTERIM_PROPOSITIONS,
				component: () =>
					import(
						/* webpackChunkName: "workerPropositions" */ './components/workerActiveProposals/WorkerActiveProposals.vue'
					),
			},
			{
				path: 'payment-requests',
				name: ROUTES.APP.WORKERS.PROFIL.PAYMENT_REQUESTS,
				component: () =>
					import(
						/* webpackChunkName: "workerPaymentRequests" */ './views/profil/PaymentRequests.vue'
					),
			},
			{
				path: 'reviews',
				name: ROUTES.APP.WORKERS.PROFIL.INTERIM_REVIEWS,
				component: () =>
					import(
						/* webpackChunkName: "interimReviews" */ './components/workerReviews/WorkerReviews.vue'
					),
			},
		],
	},
	{
		name: ROUTES.APP.WORKERS.REGISTRATIONS,
		path: 'registrations',
		component: () =>
			import(/* webpackChunkName: "workers" */ './views/Registrations.vue'),
		meta: {
			breadcrumbs: <BreadcrumbProps>{
				items: [
					{
						label: i18n.global.t('breadcrumbs.workers.registrations'),
						icon: 'user-circle-plus',
					},
				],
			},
		},
	},
];

export default routes;
